import { createFileRoute, Outlet } from "@tanstack/react-router";
import { m } from "@/lib/paraglide/messages.js";

// /domains/*: the Domain group of the sidebar. Its pages share this crumb; there is no /domains
// page yet, so the crumb names the group without linking to it.
export const Route = createFileRoute("/_authenticated/domains")({
  staticData: { crumb: m.portal_nav_domains, crumbUnlinked: true },
  component: Outlet,
});
